// services/userSessionHandler.js
import router from '@/router';

const userSessionHandler = {
    /**
     * Handle user logout when receiving 401 from internal API
     * This clears localStorage and redirects to login
     * Note: Store cleanup should be handled separately to avoid circular imports
     */
    handleUserLogout() {
        // Clear auth data from localStorage
        localStorage.removeItem('token');
        
        // Redirect to login page
        router.push('/login');
    },

    /**
     * Check if a 401 error comes from external feed APIs
     * @param {Object} error - Axios error object
     * @returns {boolean} - True if it's an external feed error (don't logout user)
     */
    isExternalFeedError(error) {
        const requestUrl = error.config?.url || '';
        return requestUrl.startsWith('/parsing');
    }
};

export default userSessionHandler;